import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Microsoft360ViewContext } from '../../../shared/contexts/microsoft-360-view.context';
import { MicrosoftSharedVoicemailGroupsMembershipContext } from '../../../shared/contexts/microsoft-shared-voicemail-groups-membership.context';
import { combineLatest, Subscription } from 'rxjs';
import {
  Microsoft360View,
  MicrosoftSharedVoicemailGroupOption,
  MicrosoftSharedVoicemailGroupsFieldConfig,
} from '../../../shared/models/generated/ziroModels';
import { SharedVoicemailGroupEntity } from './shared-voicemail-groups-memberships-form/shared-voicemail-groups-memberships-form.component';

@Component({
  selector: 'ziro-shared-voicemail-groups-memberships',
  templateUrl: './shared-voicemail-groups-memberships.component.html',
  standalone: false,
})
export class SharedVoicemailGroupsMembershipsComponent implements OnInit, OnDestroy {
  private _microsoft360ViewContext = inject(Microsoft360ViewContext);
  private _sharedVoicemailGroupsMembershipContext = inject(MicrosoftSharedVoicemailGroupsMembershipContext);

  microsoft360View: Microsoft360View;
  fieldConfig: MicrosoftSharedVoicemailGroupsFieldConfig;
  inventory: MicrosoftSharedVoicemailGroupOption[];
  originalEntity: SharedVoicemailGroupEntity = { sharedVoicemailGroups: {} };
  isLoading = true;
  private _subscriptions = new Subscription();

  ngOnInit(): void {
    this._sharedVoicemailGroupsMembershipContext.refresh().subscribe(() => {
      this._getInitialData();
    });
  }

  private _getInitialData(): void {
    const contextsSub = combineLatest([
      this._microsoft360ViewContext.state$,
      this._sharedVoicemailGroupsMembershipContext.state$,
    ]).subscribe(([microsoft360View, fieldConfig]) => {
      this.microsoft360View = microsoft360View;
      this.fieldConfig = fieldConfig;
      this.inventory = fieldConfig.writeGroupList.concat(fieldConfig.readOnlyGroupList);
      this._setOriginalEntity();
      this.isLoading = false;
    });
    this._subscriptions.add(contextsSub);
  }

  private _setOriginalEntity(): void {
    const memberships = this.microsoft360View.sharedVoicemailGroupMemberships;
    this.inventory.forEach((group: MicrosoftSharedVoicemailGroupOption) => {
      const id = group.id;
      const displayName = group.displayName;
      this.originalEntity.sharedVoicemailGroups[displayName] = memberships
        ? !!memberships.find((membership: MicrosoftSharedVoicemailGroupOption) => membership.id === id)
        : false;
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
